import React, { useState } from 'react';
import UpdateApplication from './UpdateApplication';
import FundingApplicationProgress from './FundingApplicationProgress';

const FundingApplicationManagement = ({ data }) => {
  const [applicationData, setApplicationData] = useState(data);

  return (
    <div style={{ display: 'flex', gap: '10px' }}>
      <UpdateApplication 
        data={applicationData} 
      />
      
      <FundingApplicationProgress 
        data={applicationData} 
      />
    </div>
  );
};

export default FundingApplicationManagement;